import { combineReducers } from 'redux';
import { merge } from 'lodash'
import { normalize, schema } from 'normalizr';

// Define a vtypes schema
const vtypeSchema = new schema.Entity('vtypes', {}, { idAttribute: 'id' });
const vtypeListSchema = [vtypeSchema];

const defaultVtypeParams = {
  vtypeFetched: false,

}


function byId(state = {}, action) {
  if (action.type === 'SAVED_VTYPE') {
    let vtypeId = action.payload.id
    return {
      ...state,
      [vtypeId]: action.payload
    }

  }
  if (action.type === 'FETCHED_VTYPE') {
    const normalizedVtype = normalize(action.payload, vtypeListSchema);
    return merge({}, state, normalizedVtype.entities.vtypes)
  }
  if (action.type === 'DELETED_VTYPE') {
    if (action.payload.msg === "Success") {
      const vtypeID = action.payload.id;
      return {
        ...state,
        [vtypeID]: {
          ...state[vtypeID],
          status: 0
        }
      }
    } else {
      return state
    }
  }
  if (action.type === 'RESET_DATA') {
    return {}
  } else {
    return state
  }
}

function saveEditedResponse(state = {}, action) {
  if (action.type === 'SAVED_VTYPE_RES') {
    return action.payload
  } else {
    return state
  }
}


function notifications(state = {}, action) {
  if (action.type === 'SAVED_SEGMAP') {

    return {
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        save: {
          status: (action.txn === "success" || action.txn === "Success") ? 'success' : 'error',
          msg: action.txn
        }
      }
    }
  }
  if (action.type === 'DELETED_VTYPE') {
    return {
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        delete: {
          status: action.payload.msg === "Success" ? 'success' : 'error',
          msg: action.payload.msg
        }
      }
    }
  }
  if (action.type === 'NOTIFICATION_DONE_VTYPE') {
    const { id, type } = action.payload
    // Remove the 'id' element from state
    const { [id]: idValue, ...restOfState } = state;
    // Remove the 'type' from the 'id' element
    const { [type]: removedValue, ...restOfId } = idValue;
    // Merge back together
    const finalState = { ...restOfState, [id]: restOfId };
    return finalState

  } else {
    return state
  }
}


function params(state = defaultVtypeParams, action) {
  if (action.type === 'FETCHED_VTYPE') {
    return {
      ...state,
      vtypeFetched: true,
      isFetching: false
    }
  }
  if (action.type === 'DELETED_VTYPE') {
    return {
      ...state,
      isDelFetched: true
    }
  }
  if (action.type === 'RESET_DATA') {
    return defaultVtypeParams
  } else {
    return state
  }
}

const vtype = combineReducers({
  byId,
  notifications,
  params,
  saveEditedResponse,
});

export default vtype;

